"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _EmptyState = _interopRequireDefault(require("./EmptyState"));

var _svgs = require("../../lib/svgs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/**
 * Displays message that no comments exist
 * @param {Object} props - props for component
 * @returns {undefined}
 */
var DisabledCreationEmptyState = function DisabledCreationEmptyState() {
  return /*#__PURE__*/_react.default.createElement(_EmptyState.default, null, /*#__PURE__*/_react.default.createElement(_EmptyState.default.Illustration, null, /*#__PURE__*/_react.default.createElement(_svgs.CommentIllustration, {
    size: "L"
  })), /*#__PURE__*/_react.default.createElement(_EmptyState.default.Title, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.empty-state.shared.title"
  })), /*#__PURE__*/_react.default.createElement(_EmptyState.default.Subtitle, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.empty-state.nocomment.subtitle"
  })));
};

var _default = DisabledCreationEmptyState;
exports.default = _default;